import { createAction } from '@reduxjs/toolkit';

export const setListingsFilter = createAction('setListingsFilter');
export const resetListingsFilter = createAction('resetListingsFilter');
